import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RecargaService } from '../../../../services/recarga.service';
import { PermissaoService } from '../../../../services/permissao.service';
import { ToastrService } from 'ngx-toastr';
declare var bootstrap: any;

@Component({
  selector: 'app-modal-sem-creditos',
  templateUrl: './modal-sem-creditos.component.html',
  standalone: false
})
export class ModalSemCreditosComponent {
  @Output() fecharModalEvent = new EventEmitter<void>();
  @Input() mostrarModal: boolean = false;
  private modalInstance: any;

  constructor(private recargaService: RecargaService, private permissaoService: PermissaoService, private toastr: ToastrService) {}

  ngAfterViewInit(): void {
    const modalElement = document.getElementById('modalSemCreditos');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement);
      if (this.mostrarModal) {
        this.modalInstance.show();
      }
    } else {
      console.error('Elemento do modal não encontrado!');
    }
  }
  
  ngOnChanges(): void {
    if (this.modalInstance) {
      if (this.mostrarModal) {
        this.modalInstance.show();
      } else {
        this.modalInstance.hide();
      }
    }
  }

  fecharModal(): void {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
    this.fecharModalEvent.emit();
  }

  navegarParaRecarga(event: Event): void{
    if(this.permissaoService.canFazerRecarga()){
      this.recargaService.navegarParaRecargas(event);
    }
    else {
     this.toastr.warning('Você não tem permissão para acessar recargas, solicite a um usuário master ou com a permissão habilitada'); 
     this.fecharModal();
    }    
  }
}
